import store from '../../store/store'
// import { ability } from '../../permissions/rules'

const getEmployee = ({ companyId, employeeId }) => store.dispatch('employee/getEmployee', { companyId, employeeId })

const fetchCurrentEmployee = async (to, from, next) => {
  const companyId = to.params.companyId
  const employeeId = to.params.employeeId

  try {
    await getEmployee({ companyId, employeeId })
    next()
  } catch (e) {
    console.log(e)
    next({ name: 'employees' })
  }
}

export default fetchCurrentEmployee
